import {
  getReviewEmailExpenses,
  getReviewBankTransactions,
} from '@easy-expense/data-firestore-client';
import { ReviewableTransaction } from '@easy-expense/data-schema-v2';
import React from 'react';
import { useParams } from 'react-router-dom';

import { ReviewExpenseEdit } from '../components/Expense/Edit/ReviewExpenseEdit.component';
import { ReviewTransactionEdit } from '../components/Expense/Edit/ReviewTransactionEdit.component';

export const ReviewTransactionEditPage: React.FC = () => {
  const { transactionType } = useParams();

  const [transactions, setTransactions] = React.useState<ReviewableTransaction[]>([]);
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    if (transactionType === 'bank') {
      const sortedTransactions = getReviewBankTransactions().sort((a, b) => {
        return b.date.localeCompare(a.date);
      });
      setTransactions(sortedTransactions);
    } else {
      setTransactions(getReviewEmailExpenses());
    }
  }, []);

  if (transactionType === 'bank') {
    return (
      <ReviewExpenseEdit
        reviewExpense={transactions[index]}
        next={() => {
          setIndex(index + 1);
        }}
        skip={() => {
          setIndex(index + 1);
        }}
      />
    );
  }

  return (
    <ReviewTransactionEdit
      reviewExpense={transactions[index]}
      next={() => {
        setIndex(index + 1);
      }}
    />
  );
};
